import { useEffect, useRef } from "react";

export default function HeroSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const els = sectionRef.current?.querySelectorAll(".reveal");
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative min-h-[100dvh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Flat%20lay%20fashion%20ecommerce%20collection%20sneakers%20streetwear%20hoodies%20jackets%20accessories%20arranged%20on%20warm%20terracotta%20linen%20background%20soft%20natural%20morning%20lighting%20editorial%20product%20photography%20minimal%20aesthetic%20high%20detail%20harmonious%20composition%20earthy%20warm%20tones&width=1920&height=1080&seq=hero-v2-main&orientation=landscape&nocache=true"
          alt="Kakobuy Spreadsheet produkty"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-24 pb-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
              Kakobuy Spreadsheet Polska
              <br />
              <span className="text-primary-300">Największa Baza Produktów i Linków</span>
            </h1>
          </div>

          <div className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-150">
            <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
              Znajdź najlepsze produkty z Chin dzięki aktualizowanemu Kakobuy Spreadsheet.
              Gotowe linki, kategorie produktów, QC zdjęcia oraz kompletny przewodnik zakupowy dla użytkowników z Polski.
            </p>
          </div>

          <div className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-300">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-base font-semibold px-8 py-3.5 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap shadow-lg"
              >
                Zobacz Kakobuy Spreadsheet
                <i className="ri-external-link-line" />
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 bg-background-50/10 backdrop-blur-sm text-background-50 text-base font-medium px-8 py-3.5 rounded-full border border-background-200/40 hover:bg-background-50/20 transition-colors whitespace-nowrap"
              >
                Buy it now
                <i className="ri-shopping-bag-line" />
              </a>
            </div>
          </div>

          <div className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-450">
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-background-300/80">
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-accent-400" />
                Aktualizowane listy produktów
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-accent-400" />
                Kategorie premium
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-accent-400" />
                Poradnik dla początkujących
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-accent-400" />
                Bezpieczne zakupy
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-300 text-xl" />
      </div>

      <style>{`
        .animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}